module.exports = __webpack_public_path__ + "media/contract/Contract-3-8e9acc51.jpeg";